import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import {
  APPOINTMENT_ORDER_OPTION_GROUPS,
  getAppointmentOrderGroupLabel
} from '../utils/appointmentOrderOptions';

const MedicalOrderDraftEditor = ({
  title,
  description,
  addLabel,
  removeLabel,
  selectLabel,
  descriptionPlaceholder,
  drafts,
  onAdd,
  onChange,
  onRemove,
  t,
  disabled = false,
  keyPrefix
}) => (
  <section className="medical-order-editor" aria-label={title}>
    <div className="medical-order-editor__heading">
      <h4 className="report-subsection-title">{title}</h4>
      <p>{description}</p>
    </div>

    <div className="medical-order-editor__rows">
      {drafts.map((draft, index) => (
        <div className="medical-order-editor__row" key={`${keyPrefix}-${index}`}>
          <select
            aria-label={`${title} ${index + 1}`}
            value={draft.check_type}
            onChange={(event) => onChange(index, 'check_type', event.target.value)}
            disabled={disabled}
          >
            <option value="">{selectLabel}</option>
            {APPOINTMENT_ORDER_OPTION_GROUPS.map((group) => (
              <optgroup key={group.id} label={getAppointmentOrderGroupLabel(group, t)}>
                {group.options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {t(option.labelKey)}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>

          <input
            type="text"
            aria-label={descriptionPlaceholder}
            value={draft.description}
            onChange={(event) => onChange(index, 'description', event.target.value)}
            placeholder={descriptionPlaceholder}
            disabled={disabled}
          />

          <button
            type="button"
            className="medical-order-editor__remove"
            onClick={() => onRemove(index)}
            disabled={disabled}
            title={removeLabel}
            aria-label={`${removeLabel} ${index + 1}`}
          >
            <Trash2 size={17} aria-hidden="true" />
          </button>
        </div>
      ))}
    </div>

    <div className="medical-order-editor__footer">
      <button
        type="button"
        className="medical-order-editor__add"
        onClick={onAdd}
        disabled={disabled}
      >
        <Plus size={17} aria-hidden="true" />
        <span>{addLabel}</span>
      </button>
    </div>
  </section>
);

export default MedicalOrderDraftEditor;
